/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AutoTranslateLanguageRequest
 */
export interface AutoTranslateLanguageRequest {
    /**
     * 
     * @type {string}
     * @memberof AutoTranslateLanguageRequest
     */
    from?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AutoTranslateLanguageRequest
     */
    all: boolean;
}

/**
 * Check if a given object implements the AutoTranslateLanguageRequest interface.
 */
export function instanceOfAutoTranslateLanguageRequest(value: object): value is AutoTranslateLanguageRequest {
    if (!('all' in value) || value['all'] === undefined) return false;
    return true;
}

export function AutoTranslateLanguageRequestFromJSON(json: any): AutoTranslateLanguageRequest {
    return AutoTranslateLanguageRequestFromJSONTyped(json, false);
}

export function AutoTranslateLanguageRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AutoTranslateLanguageRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'from': json['from'] == null ? undefined : json['from'],
        'all': json['all'],
    };
}

export function AutoTranslateLanguageRequestToJSON(json: any): AutoTranslateLanguageRequest {
    return AutoTranslateLanguageRequestToJSONTyped(json, false);
}

export function AutoTranslateLanguageRequestToJSONTyped(value?: AutoTranslateLanguageRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'from': value['from'],
        'all': value['all'],
    };
}

